import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['redirectField']

  connect() {
    document.addEventListener('tablist:tabChanged', this.handleTabChange)
  }

  disconnect() {
    document.removeEventListener('tablist:tabChanged', this.handleTabChange)
  }

  handleTabChange = event => {
    if (event.detail.id !== 'tablist-reporting-cycle-tabs') return

    const panelId = event.detail.tabPanelId

    if (!panelId) return

    // Extract the controller name from tabPanelId by removing 'panel-'
    if (panelId.startsWith('panel-')) {
      const controllerName = panelId.replace(/^panel-/, '')

      this.updateRedirectField(controllerName)

      // Update URL to reflect new controller name while preserving query params
      this.updateUrl(controllerName)
    }
  }

  // Only update redirect field if it exists (form view only)
  updateRedirectField = controllerName => {
    if (this.hasRedirectFieldTarget) {
      this.redirectFieldTarget.value = controllerName
    }
  }

  // The reporting cycle page is very complex. When the sidebar is open, there are two tabs manupulating the URL.
  // We need to make sure they both work together, so this bypasses the push state mechanism in the tab list contorller
  // and handles it ourselves
  updateUrl = controllerName => {
    const currentUrl = new URL(window.location.href)
    const pathParts = currentUrl.pathname.split('/')

    // Replace the last part of the path with the new controller name
    // e.g., /admin/org/service_records/summary/display -> /admin/org/service_records/summary/clients
    pathParts[pathParts.length - 1] = controllerName === 'summary' ? 'display' : controllerName

    const newUrl = pathParts.join('/') + currentUrl.search

    history.pushState({ summary: { controllerName, tabPanelId: `panel-${controllerName}` } }, '', newUrl)
  }
}
